import type {Base64ObjectInput, Question, QuestionStatus} from '@cp/model';
import {questionAdminUpdate} from '../../api/callable/question';
import {useFunctionWrap} from '../helper/function/useFunctionWrap';

export function useUpdateQuestion() {
  const {
    fn: updateQuestion,
    loading,
    error,
  } = useFunctionWrap(
    async (
      moduleId: string,
      questionId: string,
      topic?: string,
      difficulty?: number,
      questionText?: string,
      hint?: string,
      options?: string[],
      answer?: string,
      explanation?: string,
      status?: QuestionStatus,
      statusNote?: string,
      image?: Base64ObjectInput | null,
      graphJsonString?: string | null,
      seedQuestionId?: string | null,
    ): Promise<Question> =>
      questionAdminUpdate({
        moduleId,
        questionId,
        topic,
        difficulty,
        questionText,
        hint,
        options,
        answer,
        explanation,
        status,
        statusNote,
        image: image !== undefined ? image : undefined,
        graphJsonString: graphJsonString !== undefined ? graphJsonString : undefined,
        seedQuestionId: seedQuestionId !== undefined ? seedQuestionId : undefined,
      }) as Promise<Question>,
  );

  return {
    updateQuestion,
    loading,
    error,
  };
}
